module.exports = __webpack_public_path__ + "images/placeholder_9e4de6752856ec71917957b90fb71409.jpg";